import React from 'react';
import { node, oneOf, oneOfType, string } from 'prop-types';
import Overlay from '../Overlay';
import { textOverflow } from './config';

const OverlayWrapper = ({ children, overflow, text }) => {
  switch (overflow) {
    case 'clip':
    case 'ellipsis':
      return (
        // TODO: will upgrade to Ajaib-Lib overlay/tooltip when it's ready
        <Overlay placement="top" text={text}>
          {children}
        </Overlay>
      );
    default:
      return children;
  }
};

OverlayWrapper.propTypes = {
  overflow: oneOf(Object.keys(textOverflow)),
  text: oneOfType([node, string]),
};

export default OverlayWrapper;
